var styles = {"bodyBackdrop":"styles_body-backdrop__Vz-n0"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
